// extracted by mini-css-extract-plugin
module.exports = {"slider-block":"slider-block_slider-block__SxOzN","swiper":"slider-block_swiper__p5rUB"};